import React, { useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/aiservices'

const EditAgentAppModal = ({ data, handleRefresh, index, assistantId }) => {
  console.log(data, 'datadata')
  const AppService = useAppServices()
  const [openEditProduct, setOpenEditProduct] = useState(false)
  const [processing, setProcessing] = useState(false)

  const handleModal = () => {
    setOpenEditProduct(true)
  }

  const closeEditProduct = () => {
    setOpenEditProduct(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const newEntry = {
      appId: e.target.appId.value,
      name: e.target.name.value,
      description: e.target.description.value,
      assistant_id: data?.assistant_id,
    }
    // Check if document exists
    const { response: existingDoc } = await AppService.app_agent.getAll({
      query: `assistantId=${assistantId}`,
    })

    console.log('existingDoc', existingDoc)

    let res
    if (existingDoc?.data?.length) {
      // const currentData = existingDoc.data
      const updatedPartnerData = [...existingDoc.data] // clone array
      console.log('updatedPartnerData', updatedPartnerData)
      updatedPartnerData[index] = newEntry // update at index

      console.log('updatedPartnerData[index]', updatedPartnerData[index])
      console.log('newEntry', newEntry)
      const updatedPayload = {
        assistantId: assistantId,
        applications: updatedPartnerData, // use updatedPartnerData instead of existingDoc.data[0].applications
      }

      res = await AppService.app_agent.update({
        payload: updatedPayload,
      })
    }

    setProcessing(false)
    setOpenEditProduct(false)
    handleRefresh()
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={style}
            encType="multipart/form-data"
          >
            <MDTypography variant="h5" mb={2}>
              Edit App Agent
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">App ID</MDTypography>
              <MDInput label="App ID" name="appId" fullWidth required defaultValue={data.appId} />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">description</MDTypography>
              <MDInput
                label="description"
                name="description"
                fullWidth
                defaultValue={data.description}
                multiline
                rows={4}
              />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditAgentAppModal
